module.exports = __webpack_public_path__ + "static/img/logo111.b2cdcc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo111.png
// module id = xpax
// module chunks = 1